import React from 'react'
import { useLocation } from 'react-router-dom'

import { MenuContainer, StyledLink } from './menu.styled'

interface Props {
  isScrollable?: boolean
}

export const Menu = ({ isScrollable }: Props) => {
  const { pathname } = useLocation()
  return (
    <MenuContainer isScrollable={isScrollable} className="menu">
      <p className="menu-label">General</p>
      <ul className="menu-list">
        <li>
          <StyledLink to="/" $isActive={pathname === '/'}>
            Start
          </StyledLink>
        </li>
      </ul>
      <p className="menu-label">Consignments</p>
      <ul className="menu-list">
        <li>
          <StyledLink to="/consignments/booking" $isActive={pathname === '/consignments/booking'}>
            Booking
          </StyledLink>
        </li>
      </ul>
      <p className="menu-label">Locations</p>
      <ul className="menu-list">
        <li>
          <StyledLink to="/locations/terminal-groups" $isActive={pathname === '/locations/terminal-groups'}>
            Terminal Groups
          </StyledLink>
          <StyledLink to="/locations/merchant-warehouses" $isActive={pathname === '/locations/merchant-warehouses'}>
            Merchant Warehouses
          </StyledLink>
        </li>
      </ul>
      <p className="menu-label">Pallets</p>
      <ul className="menu-list">
        <li>
          <StyledLink to="/pallets/terminal-relations" $isActive={pathname === '/pallets/terminal-relations'}>
            Terminal Relations
          </StyledLink>
        </li>
        <li>
          <StyledLink to="/pallets/configurations" $isActive={pathname === '/pallets/configurations'}>
            Configurations
          </StyledLink>
        </li>
      </ul>
    </MenuContainer>
  )
}
